module.exports = __webpack_public_path__ + "fonts/ralewaymedium.5943e29.woff";